import TypeFlow from './TypeFlow'

export default class YearMonthDateTypeFlow extends TypeFlow {
  inputFormat () {
    return 'YYYY-MM-DD'
  }

  open () {
    this.component.showYearPicker()
  }

  ok () {
    if (this.component.show === 'year') {
      this.component.showMonthPicker()
    } else {
      this.component.close()
    }
  }

  selectYear (year) {
    this.date.year(year)
    if (this.component.autoContinue) {
      this.component.showMonthPicker()
    }
  }

  selectDay (year, month, day) {
    super.selectDay(year, month, day)

    if (this.component.autoClose) {
      this.component.close()
    }
  }
}
